export default "__VITE_ASSET__CXdWDfYw__"